// extracted by mini-css-extract-plugin
export default {"container":"Ho-z","brandName":"Io-z","productName":"Jo-z","productNamePdpEnhancements":"Ko-z","breakLongProductName":"Lo-z"};